const API_BASE_URL: string = import.meta.env.VITE_API_BASE_URL ?? "http://localhost:3000";

/** The backend's base URL: VITE_API_BASE_URL (a deployed stack's API), else the local dev server. Its config decides the environment. */
export const backendBase = (): string => API_BASE_URL;
